<template>
  <v-container class="fill-height addadvertiser" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12">
        <v-card class="elevation-12">
<template>
  <v-container>
    <v-row class="text-center">
      <v-col cols="12">
            <!---- Start Preview ---->
            <v-row align="center" justify="center">
            <v-col cols="12" sm="12" md="12">
            <div class="row justify-content-center border py-5">
              <table width="95%" style="border:1px solid #b3d4fc;">
                <tr>
                  <td  style="vertical-align:top;" width="30%">
                   <div class="col-lg-12 col-md-12 padding-right-0 left-content">
                     <img class="leftsection" width="100%" :src="leftsection" >
                   </div>
                  </td>
                   <td colspan="2" width="70%" :style="{ 'vertical-align':'top', 'background-image': 'url(' + rightsection + ')','background-size':'100% 94%' }">
                            <div class="col-lg-12 col-md-12 draggablecontent" :style="{ 'background-image': 'url(' + adhere + ')' }"  >
                            <draggable class="draggable-list" id="rightcontent"  @end="checkMove($event)"  group="my-group">
                              <div class="postionsection" >
                               <!-- <div id="bannercontentimage" v-if="bannercontentimage">
                                        <img class="list-item" width="100%"  height="100%" alt="Avatar" :src="bannerimage" > 
                                  </div> 
                                  <div id="bannercontenthtml" v-if="bannercontenthtml">
                                          {{bannercontent}}
                                  </div>  -->
                                  <div class=" bannercontentimage" v-html="bannercontent">
                                  </div>
                              </div>    
                          </draggable>
                    </div> 
                    </td>  
                </tr>  
            </table>   
            </div>
            </v-col>
        </v-row>
      <!---- End Preview ---->
      </v-col>
    </v-row>
  </v-container>
  </template>
  </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import draggable from "vuedraggable";
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

//var adserverURL ="http://local.adserver.com/www/";

  export default {
    name: 'Quizstartemplate',
    props:[
       'bannerposition',
       'bannercontentimage',
       'bannercontenthtml',
       'bannercontent',
       'bannerimage',
    ],
    components: {
           draggable,
        },
    data: () => ({
      leftsection : require("@/assets/quizstarleftsection.png"),
      rightsection :  require("@/assets/quizstarcentersection.png"),
      adhere: require("@/assets/506.jpg"),
     }),
      mounted() {
        this. defaultsection();
     },
   computed:{
     baseURL() {
              const url = process.env.VUE_APP_BASEAPI.slice(0, -4);
              return url;
            }
     },
    methods: { 
     checkMove: function(evt){
        this.$emit("update:bannerposition", evt.to.id);
    },  
    defaultsection()
    {
       this.$emit("update:bannerposition", "centercontent");
    }          
    }
  }
</script>
<style scoped>
.row {
  margin-left: 0px;
}
.padding-top-0{padding-top: 0px !important;}
.padding-right-0{padding-right: 0px !important;}
.padding-bottom-0{padding-bottom: 0px !important;}    
.draggable-list {
  color: #fff;
  border: 1px solid;
  height: 150px;
}
.header-content{width:100%;height: 46px;}
.left-content{padding-top:0px;padding-right:0px; }
.center-content{height: 100%;}
.right-content{height: 100%;}
.footer-content{height: 100%; border:1px solid #b3d4fc;}
.draggablecontent{background-size: 100% 100%;margin-top: 37%;width: 50%;margin-left: 25%;}
#bannercontentimage{width:100%;height:100%;position: relative;}
#bannercontenthtml{width:100%;height:100%;position: relative;color:#000; background-color: #fff;}
.postionsection{width: 100%;height: 150px;}
.leftsection{padding-bottom:16px;}
</style>